module.exports = __webpack_public_path__ + "img/view-carousel-outline.eefb5eea.svg";